const initialState = {
  loadingMotivos: false,
  loadingSubmit: false,
  motivos: [],
  error: null
}

export default function rejeitarplanoReducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_MOTIVOS_REJEICAO_REQUEST':
      return {
        ...state,
        loadingMotivos: true,
        error: null,
        motivos: []
      }

    case 'FETCH_MOTIVOS_REJEICAO_SUCCESS':
      return {
        ...state,
        loadingMotivos: false,
        motivos: action.payload || [],
        error: null
      }

    case 'FETCH_MOTIVOS_REJEICAO_FAILURE':
      return {
        ...state,
        loadingMotivos: false,
        error: action.payload || true
      }

    case 'REJEITAR_PLANO_REQUEST':
      return {
        ...state,
        loadingSubmit: true,
        error: null
      }

    case 'REJEITAR_PLANO_SUCCESS':
      return {
        ...state,
        loadingSubmit: false,
        error: null
      }

    case 'REJEITAR_PLANO_FAILURE':
      return {
        ...state,
        loadingSubmit: false,
        error: action.payload || true
      }

    case 'CLEAR_REJEITAR_PLANO':
      return initialState

    default:
      return state
  }
}